import React from "react";
import getDates from "../../../shared/services/date.service";
import styles from "./winterTimeRangeForm.module.scss";
import WinterMaintenceTimeRange from "./WinterMaintenceTimeRange";
import { withWinterTimeRange } from "../../../shared/containers/containerWinterMaintenceTimeRange";
import WinterMaintenceButtonWrapper from "./WinterMaintenceButtonWrapper";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import WinterMaintenceModeSwitcher from "./WinterMaintenceModeSwitcher";

const isInvalidTime = (startDate, startTime, endDate, endTime) => {
  if (startDate === null || startTime == null || endDate === null || endTime === null) {
    return true;
  }

  let startHour = startTime.getHours();
  let startMin = startTime.getMinutes();
  let endHour = endTime.getHours();
  let endMin = endTime.getMinutes();

  let rangeStartDate = new Date(startDate);
  rangeStartDate.setHours(startHour);
  rangeStartDate.setMinutes(startMin);

  let rangeEndDate = new Date(endDate);
  rangeEndDate.setHours(endHour);
  rangeEndDate.setMinutes(endMin);

  let startDateUtc = getDates.getNullTimeDateUtcNumber(startDate);
  let endDateUtc = getDates.getNullTimeDateUtcNumber(endDate);

  return startDateUtc === endDateUtc && rangeStartDate > rangeEndDate;
};

const WinterMaintenceTimeRangeForm = (props) => {
  const { onHandleChangeStore, rangeStartDate, rangeStartTime, rangeEndDate, rangeEndTime, winterAreas, isReportMode } = props;

  if (winterAreas === null || winterAreas.length === 0) {
    return null;
  }

  const startDate = getDates.getNullTimeDateUtcNumber(rangeStartDate);
  const endDate = getDates.getNullTimeDateUtcNumber(rangeEndDate);
  const currentDate = getDates.getNullTimeDateUtcNumber(new Date());

  let isTimeInvalid = isInvalidTime(rangeStartDate, rangeStartTime, rangeEndDate, rangeEndTime);

  const _startDate = new Date(rangeStartDate);
  const _startTime = new Date(rangeStartTime);
  _startDate.setHours(_startTime.getHours());
  _startDate.setMinutes(_startTime.getMinutes());
  _startDate.setSeconds(0);

  const _endDate = new Date(rangeEndDate);
  const _endTime = new Date(rangeEndTime);
  _endDate.setHours(_endTime.getHours());
  _endDate.setMinutes(_endTime.getMinutes());
  _endDate.setSeconds(0);

  const diffTime = Math.abs(_endDate - _startDate);

  const isButtonDisabled =
    !rangeStartDate ||
    !rangeStartTime ||
    !rangeEndDate ||
    !rangeEndTime ||
    isNaN(rangeStartDate) ||
    isNaN(rangeStartTime) ||
    isNaN(rangeEndDate) ||
    isNaN(rangeEndTime) ||
    startDate > currentDate ||
    startDate > endDate ||
    diffTime > (isReportMode ? 3600000 : 86400000) ||
    isTimeInvalid;

  return (
    <React.Fragment>
      <WinterMaintenceModeSwitcher />
      <div className={styles.container_itemsTimeIntellegence}>
        <WinterMaintenceTimeRange onHandleChangeStore={onHandleChangeStore} valueStore={props} />
        <div className={styles.container_itemsTimeButtom}>
          <WinterMaintenceButtonWrapper disabled={isButtonDisabled} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default withWinterMaintence(withWinterTimeRange(React.memo(WinterMaintenceTimeRangeForm)));
